import { C } from 'src/app/@shared/constants';
import { ContactPersonListItemDto } from '@api/contact-person/@shared/contact-person-list-item.dto';
import { ContactPersonModel } from './contact-person.model';
import { ContentOptions, ContentService } from 'src/app/@core/content.service';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PersonModel, PersonSource } from 'src/app/person/@shared/person.model';
import { ProtoUrl } from 'src/app/@shared/protoUrl';
import { map, tap, timeout } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ContactPersonService extends ContentService<PersonModel, PersonSource> {
  constructor(private http: HttpClient) { super(); }

  public loadContent(id: string, options: ContentOptions<PersonSource> = {}): Observable<PersonModel[]> {
    const filter = this.getNormalizedFilter(id, options.filter);
    let totalCount = 0;

    return this.http.get<ContactPersonListItemDto[]>(ProtoUrl.getUrl('contact-persons', {
      filter,
    }), {
      observe: 'response',
    })
      .pipe(timeout(C.DEFAULT_TIMEOUT),
        tap((response: HttpResponse<ContactPersonListItemDto[]>) => {
          const count = Number(response.headers.get('x-total-count'));

          totalCount = Number.isFinite(count)
            ? count
            : response.body?.length || 0;
        }),
        map((response) => { return (response.body || []).map((contact) => { return new ContactPersonModel(contact); }); }),
        tap((items) => { return this.setItems(items, id, filter, totalCount); }));
  }
}
